import deviceDetect from '@tools/device-detect';
import googlePlacesHelpers from '@tools/geoservices/google-places-helpers';
import header from '@organisms/header';
import banner from '@molecules/banner';
import favoriteBusHandler from '@molecules/favorite-bus-handler';
import proposalBusHandler from '@molecules/proposal-bus-handler';
import sliderManager from '@molecules/slider-manager';
import deobfuscate from '@organisms/deobfuscate';
import accordions from '@components-molecules/accordion';

// Load styles
import '../styles/_base.scss';
import '../styles/_elements.scss';
import '../styles/_vendor.scss';
import '../styles/_atoms.scss';
import '../styles/_molecules.scss';
import '../styles/_organisms.scss';
import '../styles/_pages.scss';

// load youtube videos from Google Sheets
import 'lite-youtube-embed';

/**
 * This file contains components useful for Search Page
 * (header, device detection, cookies, login modals)
 * DO NOT ADD ANYTHING IN THIS FILE, UNLESS IT SHOULD BE USED ON SEARCH PAGE AS WELL
 * @see https://bureaux-a-partager.atlassian.net/browse/MATCH-4280
 */

deviceDetect();
banner();
header();
favoriteBusHandler();
proposalBusHandler();
sliderManager();
deobfuscate();
accordions();
window.googlePlacesHelpers = googlePlacesHelpers;

if (document.querySelector('.menu-auth') !== null) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "connected-user-menu" */ '@organisms/header/connected-user-menu'
  );
}
if (document.querySelector('.search-menu') !== null) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "search-menu" */ '@organisms/header/search-menu'
  );
}
if (document.querySelector('.sales-menu') !== null) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "sales-menu" */ '@organisms/header/sales-menu'
  );
}
if (document.querySelector('.help-menu') !== null) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "help-menu" */ '@organisms/header/help-menu'
  );
}
